import { MenuItem } from '@mui/material'
import React from 'react'
import { BiChevronRight, BiEdit } from 'react-icons/bi'

import './stylesCmt.css'

export default function CompCnfg({ Icon, ic, title, describe, onClick, user, title_btt }) {
  return (
    <MenuItem
      title={title_btt}
      className='contain-button-cnfg'
      sx={!ic ? {} : { borderTop: theme => `1px solid ${theme.palette.primary.main}` }}
      onClick={onClick}
    >
      <Icon className={'icon-modal-config'} />
      <div className='contain-button-cnfg-internal'>
        <h3>{title}</h3>
        <p>{describe}</p>
      </div>
      {user ? (
        <BiEdit size={23} className='now-circle' />
      ) : (
        <BiChevronRight size={23} className='now-circle' />
      )}
    </MenuItem>
  )
}
